import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, MessageSquare } from "lucide-react";

export const FinalCTA = () => {
  return (
    <section className="relative py-20 sm:py-28" data-testid="final-cta">
      <div className="osx-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl p-8 sm:p-14 text-center"
          style={{
            background:
              "linear-gradient(135deg, var(--osx-brand-600) 0%, var(--osx-accent-cyan) 100%)",
            boxShadow: "0 30px 80px rgba(2,132,199,0.42)",
          }}
        >
          <div className="absolute inset-0 osx-grid-bg opacity-30" aria-hidden />
          <div
            className="absolute -top-40 -right-20 w-[500px] h-[500px] rounded-full"
            style={{ background: "radial-gradient(circle, rgba(255,255,255,0.35), transparent 65%)", filter: "blur(30px)" }}
            aria-hidden
          />
          <div
            className="absolute -bottom-40 -left-20 w-[500px] h-[500px] rounded-full"
            style={{ background: "radial-gradient(circle, rgba(255,255,255,0.25), transparent 65%)", filter: "blur(30px)" }}
            aria-hidden
          />

          <div className="relative">
            <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white">
              Elegí tu plan y<br className="hidden sm:block" /> desplegalo en <span className="underline decoration-white/40 decoration-4 underline-offset-[6px]">segundos</span>.
            </h2>
            <p className="mt-5 text-base sm:text-lg text-white/85 max-w-xl mx-auto">
              Sin configuraciones complicadas. Tu servidor listo en un click con panel Pterodactyl, Anti-DDoS y soporte 24/7.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <a
                href="https://tienda.optishieldx.com/"
                target="_blank"
                rel="noreferrer noopener"
                data-testid="final-cta-primary"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl text-sm sm:text-base font-bold"
                style={{
                  background: "#ffffff",
                  color: "var(--osx-brand-600)",
                  boxShadow: "0 14px 30px rgba(0,0,0,0.18)",
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
              >
                Contratar ahora
                <ArrowRight size={16} />
              </a>
              <a
                href="https://discord.gg/ExE6pGa4df"
                target="_blank"
                rel="noreferrer noopener"
                data-testid="final-cta-discord"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl text-sm sm:text-base font-bold text-white"
                style={{
                  background: "rgba(255,255,255,0.12)",
                  border: "1px solid rgba(255,255,255,0.32)",
                  backdropFilter: "blur(10px)",
                  transition: "background-color 0.2s ease",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.22)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.12)"; }}
              >
                <MessageSquare size={16} />
                Unirse a Discord
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
